import { render, staticRenderFns } from "./zDialogoImpressao.vue?vue&type=template&id=d72b4854&scoped=true&"
import script from "./zDialogoImpressao.vue?vue&type=script&lang=js&"
export * from "./zDialogoImpressao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72b4854",
  null
  
)

export default component.exports